<template>
  <div class="detailContract" v-if="canAccessMx('CNPS_SCON_INFO_BY_ID')">
    <Header
      title="Chi tiết HĐĐT bán hàng"
      :backUrl="
        canAccessMx('CNPS_SCON_LIST_SELL')
          ? '/contract-manager?groupService=SELL'
          : '/contract-manager'
      "
    />
    <div class="d-flex">
      <ContractAction
        :actions="defaultContractAction"
        :excepts="[actCode.APPROVE_REJECT_LIQUID, actCode.SYNC_MPOS, actCode.EXPERTISE]"
      />
      <b-button
        v-if="dataPermission && dataPermission.includes('CNPS_SCON_MEGABIZ_UPDATE_STT')"
        style="height: 35px"
        class="btn btn-primary mr-2 mb-2"
        @click="openUpdateStatusModal"
        variant="primary"
      >
        Cập nhật trạng thái Megabiz
      </b-button>
    </div>

    <!-- End Breadcrumb Area -->
    <div class="row px-20 b-t-1-869fb229 pt-15">
      <div class="col-md-6 px-1">
        <McInfo :contract="dataContract" :item="customerInfo" :submitEditMcc="submitEditMcc" />
        <ContractInfo
          :dataConfigMcc="dataConfigMcc"
          :submitEditMcc="submitEditMcc"
          :contract="dataContract"
          :item="customerInfo"
          :listStatusMegabiz="statusOptions"
        />
        <CusInfo :contract="dataContract" :item="customerInfo" />
        <BankInfo :contract="dataContract" :item="customerInfo" />
        <ReceiptInfo :contract="dataContract" :item="customerInfo" @fetch-data="fetchData" />
        <SupportContactInfos :item="customerInfo" :systemConfig="systemConfig" />
        <PaymentAcceptancePoint :contract="dataContract" :item="customerInfo" />
      </div>
      <div class="col-md-6 px-1">
        <div class="form-detail">
          <div
            class="img-list-wrapper"
            v-if="
              dataContract.typeCustomer &&
              (dataContract.typeCustomer === 'HOUSEHOLD' ||
                dataContract.typeCustomer === 'COMPANY') &&
              customerInfo.businessScanUrl
            "
          >
            <h1 class="form-inner-heading">
              Ảnh giấy phép KD/Ảnh selfie/Ảnh sản phẩm/Ảnh cửa hàng...
            </h1>
            <div class="img-list">
              <ul v-viewer>
                <li v-for="(itemImg, index) in customerInfo.businessScanUrl" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                    <span
                      v-if="
                        (dataUser.typeSale === 'SALE_ADMIN' ||
                          dataUser.typeSale === 'SALE_DIRECTOR') &&
                        dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                        canAccessMx('CNPS_SCON_SAVE_IMAGES')
                      "
                      @click="removeImg(customerInfo.businessScanUrl, index, 'dkkd')"
                    >
                      <i class="bx bx-trash bx-sm"></i>
                    </span>
                  </a>
                </li>
                <li
                  v-if="customerInfo.businessScanUrl && customerInfo.businessScanUrl.length === 0"
                >
                  <div class="add-img">
                    <span class="font-size-12">Không có ảnh</span>
                  </div>
                </li>
                <li
                  v-if="
                    (dataUser.typeSale === 'SALE_ADMIN' || dataUser.typeSale === 'SALE_DIRECTOR') &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                    canAccessMx('CNPS_SCON_SAVE_IMAGES')
                  "
                >
                  <div class="ml-3 add-img">
                    <span class="text-center bx bx-plus"></span>
                    <input
                      @input="onSelectFile($event, 'dkkd', customerInfo.businessScanUrl)"
                      ref="fileInput"
                      type="file"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="img-list-wrapper"
            v-if="dataContract.typeCustomer && dataContract.typeCustomer === 'INDIVIDUAL'"
          >
            <h1 class="form-inner-heading">Ảnh hoá đơn/Ảnh selfie với cửa hàng/Ảnh sản phẩm...</h1>
            <div class="img-list">
              <ul v-viewer>
                <li v-for="(itemImg, index) in customerInfo.billScanUrl" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" />
                    <span
                      v-if="
                        (dataUser.typeSale === 'SALE_ADMIN' ||
                          dataUser.typeSale === 'SALE_DIRECTOR') &&
                        dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                        canAccessMx('CNPS_SCON_SAVE_IMAGES')
                      "
                      @click="removeImg(customerInfo.billScanUrl, index, 'bill')"
                    >
                      <i class="bx bx-trash bx-sm"></i>
                    </span>
                  </a>
                </li>
                <li v-if="customerInfo.billScanUrl && customerInfo.billScanUrl.length === 0">
                  <div class="add-img">
                    <span class="font-size-12">Không có ảnh</span>
                  </div>
                </li>
                <li
                  v-if="
                    (dataUser.typeSale === 'SALE_ADMIN' || dataUser.typeSale === 'SALE_DIRECTOR') &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                    canAccessMx('CNPS_SCON_SAVE_IMAGES')
                  "
                >
                  <div class="add-img">
                    <span class="text-center bx bx-plus"></span>
                    <input
                      @input="onSelectFile($event, 'bill', customerInfo.billScanUrl)"
                      ref="fileInput"
                      type="file"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="customerInfo.merchantBusinessAreas">
            <div
              class="img-list-wrapper"
              v-for="(item, index) in customerInfo.merchantBusinessAreas"
              :key="index"
            >
              <h1 class="form-inner-heading">
                Ảnh cửa hàng: {{ item.areaAddress }}
                <span v-show="item.areaDistrict"> - {{ item.areaDistrict }}</span>
                <span v-show="item.areaCity"> - {{ item.areaCity }}</span>
              </h1>
              <div class="img-list">
                <ul v-viewer>
                  <li v-for="(itemImg, indexx) in item.areaUrl" :key="indexx">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="itemImg" />
                      <span
                        v-if="
                          (dataUser.typeSale === 'SALE_ADMIN' ||
                            dataUser.typeSale === 'SALE_DIRECTOR') &&
                          dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                          canAccessMx('CNPS_SCON_SAVE_IMAGES')
                        "
                        @click="removeImg(item.areaUrl, indexx, 'merchant', item.id, item.areaName)"
                      >
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li v-if="(item.areaUrl && item.areaUrl.length === 0) || !item.areaUrl">
                    <div class="add-img">
                      <span class="font-size-12">Không có ảnh</span>
                    </div>
                  </li>
                  <li
                    v-if="
                      (dataUser.typeSale === 'SALE_ADMIN' ||
                        dataUser.typeSale === 'SALE_DIRECTOR') &&
                      dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                      canAccessMx('CNPS_SCON_SAVE_IMAGES') &&
                      item.areaUrl &&
                      item.areaUrl.length < 1
                    "
                  >
                    <div class="add-img">
                      <span class="text-center bx bx-plus"></span>
                      <input
                        @input="onSelectFile($event, 'merchant', item.areaUrl)"
                        ref="fileInput"
                        type="file"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <UploadMultiple
            :lsData="customerInfo.passportScanUrl"
            :canUpload="false"
            title="Ảnh CMND/CCCD/Hộ chiếu"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            :lsData="dataContract.selfieOfMerchantByContract"
            :canUpload="false"
            title="Ảnh selfie với MC"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
        </div>
      </div>
      <div class="col-md-12 px-1">
        <AppendixPackage
          :items="dataContract.lstAppendixPackages"
          :only="[
            'VIEW_APPENDIX',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'APPROVE_REJECT',
            'OPT',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        >
          <template #row-details="item">
            <p>
              <button
                v-if="canAccessMx('CNPS_SCON_UPDATE_USERNAME_SELL')"
                @click="editUsername(item.appendixPackage.userNameStr, item.appendixId)"
                style="border: 1px solid #dee2e6"
              >
                <i class="bx bx-edit-alt"></i>
              </button>
              Danh sách username:
              {{ item.appendixPackage && item.appendixPackage.userNameStr }}
            </p>
          </template>
        </AppendixPackage>
        <AppendixDevice
          :items="dataContract.lstAppendixDevices"
          :only="[
            'VIEW_APPENDIX',
            'RE_CREATE_RECEIPT',
            'APPROVE_REJECT',
            'OTP',
            'EDIT_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRecall
          :items="dataContract.lstAppendixRecalls"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT', 'OTP']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixHandover
          :items="dataContract.lstAppendixHandOvers"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT', 'OTP']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixWarranties
          :items="dataContract.lstAppendixWarranties"
          :only="['APPROVE_REJECT', 'REQUEST_ADDITIONAL', 'RE_CREATE_RECEIPT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <SignHistory :contractId="$route.params.id" />
        <div class="form-detail" v-if="historyUpdate.length > 0">
          <h1>Lịch sử chỉnh sửa thông tin hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thông tin chỉnh sửa</th>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale</th>
                  <th scope="col" class="text-left">Người duyệt/ từ chối</th>
                  <th scope="col" class="text-left">Lý do từ chối</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyUpdate" :key="index">
                <tr class="table-row">
                  <td align="left">
                    <router-link :to="`/history-approve-update/${item.updateCusReqId}`"
                      >Xem chi tiết</router-link
                    >
                  </td>
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.saleName }} <br />
                    <p class="text-primary">{{ item.saleEmail }}</p>
                  </td>
                  <td align="left">
                    <div v-if="item.rejectName">
                      {{ item.rejectName }} <br />
                      <p class="text-primary">{{ item.rejectEmail }}</p>
                    </div>
                    <div v-else>
                      {{ item.approverName }} <br />
                      <p class="text-primary">{{ item.approverEmail }}</p>
                    </div>
                  </td>
                  <td align="left">
                    {{ item.reason }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-detail" v-if="historyAssignSale.length > 0">
          <h1>Lịch sử gán hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale cũ</th>
                  <th scope="col" class="text-left">Sale đang gán</th>
                  <th scope="col" class="text-left">Người gán</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyAssignSale" :key="index">
                <tr class="table-row">
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.oldSaleName }} <br />
                    <p class="text-primary">{{ item.oldSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.newSaleName }} <br />
                    <p class="text-primary">{{ item.newSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.approverName }} <br />
                    <p class="text-primary">{{ item.approverEmail }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <HistoryInfo :dataContract="dataContract"></HistoryInfo>
      </div>
    </div>
    <ModalEdiDevice
      @close="showModalEditDevice = false"
      :showModalEditDevice="showModalEditDevice"
      :dataEdit="dataEditDevice"
      @closeSuccess="showModalEditDevice = false"
      @refeshData="getDetailContract()"
    />
    <b-modal id="modal-scoped" v-model="showmodalConfirmRemoveImage">
      <template #modal-header="{ close }">
        <h5>Xoá ảnh</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6>Bạn chắc chắn muốn xoá ảnh {{ typeImgAction }}</h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button size="sm" variant="primary" @click="confirmRemove"> Đồng ý </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <SelectEmployee @selectSale="assignNewSale" />
    <PopupApproveContract
      :customer-type="customerInfo?.customerType"
      ref="popupApproveContractRef"
      @approveContract="getDetailContract"
    />

    <UpdateStatusModal
      :visible="showUpdateStatusModal"
      :contractId="dataContract.id"
      :defaultStatus="dataContract.megabizStt"
      @update:visible="showUpdateStatusModal = $event"
      @success="handleUpdateSuccess"
      @error="handleUpdateError"
      @close="showUpdateStatusModal = false"
    />
    <ReserveContractModal
      :contract-id="dataContract.id"
      ref="reserveContractModal"
      @loading="showLoading = $event"
      @success="showSuccessMx"
      @error="showFailMx"
      @refresh="getDetailContract"
    />
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  import Config from '../../thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import ModalEdiDevice from './modal-detail-contract-paper/modal-edit-device-contract.vue'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import mxActions from './mxActions'
  import mxAppendix from './mxAppendix'
  import HistoryInfo from './component/HistoryInfo.vue'
  import { mapGetters } from 'vuex'
  import UpdateStatusModal from './UpdateStatusModal.vue'

  export default {
    data() {
      return {
        Config,
        showUpdateStatusModal: false,
        historyAssignSale: [],
        limtImg: 0,
        dataContract: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigMcc: [],
        showModalEditDevice: false,
        dataEditDevice: {},
        showmodalConfirmRemoveImage: false,
        confirmRemoveImage: false,
        typeImgAction: '',
        imageParams: {},
        ImageInsertSuccess: '',
        showLoading: false,
        historyUpdate: [],
        statusOptions: [],
      }
    },

    components: {
      ModalEdiDevice: ModalEdiDevice,
      HistoryInfo,
      UpdateStatusModal,
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    mixins: [mxActions, mxAppendix],
    async created() {
      this.fetchData()
      this.getConfigSystem()
      this.fetchDataMegabiz()
    },
    methods: {
      async fetchDataMegabiz() {
        try {
          this.loading = true
          const data = await ContractService.getListStatusMegabiz({})
          if (data.success) {
            const list = data.data.contractStt || []
            this.statusOptions = list.map(e => ({
              id: e.code,
              text: e.name,
              ...e,
            }))
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      openUpdateStatusModal() {
        this.showUpdateStatusModal = true
      },

      handleUpdateSuccess(data) {
        this.showSuccessMx(data.message)
        // Refresh data nếu cần
        this.getDetailContract()
      },

      handleUpdateError(error) {
        this.showFailMx(error.message)
      },

      async fetchData() {
        await this.getDetailContract()
        this.configSystem()
        await this.getHistoryUpdate()
        this.historySaleAssigned()
      },
      async getDetailContract() {
        try {
          this.showLoading = true
          const data = await ContractService.getDetailContractByID({
            contractId: this.$route.params.id,
          })
          if (data.code === 1000 && data.data) {
            this.dataContract = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async onSelectFile(event, key, imgData, itemIdCH) {
        const files = event.target.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFormat = fomatUpload.includes(files[0].type)
        if (!checkFormat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        if (key === 'cmnd') this.limtImg = 2
        if (key === 'bill' || key === 'dkkd') this.limtImg = 99999
        if (key === 'merchant') this.limtImg = 1
        if (this.limtImg <= imgData.length) {
          this.showFailMx('Đã đạt ảnh tối đa , xóa ảnh cũ để thêm mới')
        }

        const FileSize = files[0].size / 1024 / 1024 // in MB

        if (FileSize > 5) {
          alert('File quá lớn. Vui lòng thử lại')
          return
        }

        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'nextpay_crm/images') // NextCrm

        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            imgData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
        }

        if (key === 'merchant') this.uploadImage(key, itemIdCH)
        else this.uploadImage(key)
      },

      async uploadImage(typeImage, itemIdCH) {
        try {
          this.showLoading = true
          await CommonService.uploadImg(this.formData2).then(res => {
            if (res.code === 1000) {
              this.ImageInsertSuccess = res.data[0]
              if (typeImage === 'merchant') this.saveImage(typeImage, itemIdCH)
              else this.saveImage(typeImage)
            }
          })
        } catch (error) {
          console.log(error)
        }
      },

      async saveImage(typeImage, itemIdCH) {
        try {
          if (this.ImageInsertSuccess !== '') {
            if (typeImage === 'bill') {
              this.customerInfo.billScanUrl.splice(this.customerInfo.billScanUrl.length - 1, 1)
              this.customerInfo.billScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'dkkd') {
              this.customerInfo.businessScanUrl.splice(
                this.customerInfo.businessScanUrl.length - 1,
                1
              )
              this.customerInfo.businessScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'cmnd') {
              this.customerInfo.passportScanUrl.splice(
                this.customerInfo.passportScanUrl.length - 1,
                1
              )
              this.customerInfo.passportScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'merchant') {
              this.customerInfo.merchantBusinessAreas.map((item, index) => {
                if (item.id === itemIdCH) {
                  item.areaUrl.splice(item.areaUrl.length - 1, 1)
                  this.mcBusinessImagesArr[index] = {
                    areaId: item.id,
                    areaUrl: item.areaUrl.concat(this.ImageInsertSuccess),
                  }
                }
              })
            }

            const body = {
              billScanUrl: this.customerInfo.billScanUrl,
              businessScanUrl: this.customerInfo.businessScanUrl,
              customerId: this.customerInfo.customerId,
              merchantBusinessImagesList: this.mcBusinessImagesArr,
              passportScanUrl: this.customerInfo.passportScanUrl,
              productScanUrl: [],
              servicePackCode: this.dataContract.groupService,
              listServices: this.dataContract.serviceTypes,
            }
            const response = await ContractService.updateImg(body)
            if (response.code === 1000) {
              this.delayTime(700)
            } else {
              this.showFailMx(response.message)
              this.showLoading = false
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      delayTime(time) {
        setTimeout(() => {
          this.getDetailContract()
          this.showLoading = false
          this.showSuccessMx('Cập nhật thành công')
        }, time)
      },

      async confirmRemove() {
        this.confirmRemoveImage = true
        this.showLoading = true
        await this.removeImg(
          this.imageParams.imgData,
          this.imageParams.index,
          this.imageParams.key,
          this.imageParams.itemIdCH
        )
        this.showmodalConfirmRemoveImage = false
        this.confirmRemoveImage = false
      },

      async removeImg(imgData, index, key, itemIdCH, itemNameCH) {
        this.showmodalConfirmRemoveImage = true
        this.imageParams.imgData = imgData
        this.imageParams.index = index
        this.imageParams.key = key
        this.imageParams.itemIdCH = itemIdCH

        if (key === 'bill') this.typeImgAction = 'hoá đơn/ ảnh selfie'
        if (key === 'dkkd') this.typeImgAction = 'đăng ký kinh doanh'
        if (key === 'cmnd') this.typeImgAction = 'chứng minh nhân dân'
        if (key === 'merchant') this.typeImgAction = 'cửa hàng ' + itemNameCH

        if (this.confirmRemoveImage === false) {
          return
        }

        if (key === 'bill' || key === 'dkkd' || key === 'cmnd') {
          imgData.splice(index, 1)
        }
        if (key === 'merchant') {
          this.customerInfo.merchantBusinessAreas.map((e, i) => {
            if (e.id === itemIdCH) {
              imgData.splice(index, 1)
              const areaUrlArr = imgData
              this.mcBusinessImagesArr[i] = {
                areaId: e.id,
                areaUrl: areaUrlArr,
              }
            }
          })
        }
        await this.saveRemoveImage()
      },

      async saveRemoveImage() {
        try {
          const body = {
            billScanUrl: this.customerInfo.billScanUrl,
            businessScanUrl: this.customerInfo.businessScanUrl,
            customerId: this.customerInfo.customerId,
            merchantBusinessImagesList: this.mcBusinessImagesArr,
            passportScanUrl: this.customerInfo.passportScanUrl,
            productScanUrl: [],
            servicePackCode: this.dataContract.groupService,
            listServices: this.dataContract.serviceTypes,
          }
          const response = await ContractService.updateImg(body)
          if (response.code === 1000) {
            this.delayTime(700)
          } else {
            this.showFailMx(response.message)
            this.showLoading = false
          }
        } catch (error) {
          console.log(error)
        }
      },

      async showEditDevice(data) {
        this.showModalEditDevice = true
        this.dataEditDevice = data
      },
    },
  }
</script>

<style scoped>
  ::v-deep .dropdown.action-dropdown .dropdown-toggle::after {
    display: none !important;
  }
  ::v-deep .dropdown.action-dropdown > .btn,
  .dropdown .btn-sm {
    padding: 7px 15px !important;
  }
  ::v-deep .dropdown.action-dropdown .dropdown-menu {
    outline: none;
  }
  ::v-deep .dropdown.dropdown.action-dropdown .dropdown-item {
    width: 90%;
  }
  @media (max-width: 415px) {
    .btn-group {
      padding-bottom: 0;
    }
  }
</style>
